import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const sessionRuntime = createHostModule({
    clear: ({ channel }) => function clear(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'session.clear',
            args,
        });
    },
    getItem: ({ channel }) => function getItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'session.getItem',
            args,
        });
    },
    removeItem: ({ channel }) => function removeItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'session.removeItem',
            args,
        });
    },
    setItem: ({ channel }) => function setItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'session.setItem',
            args,
        });
    },
});
//# sourceMappingURL=session.runtime.js.map